import React from 'react';
import PropTypes from 'prop-types';
import s from './ColorBar.styles';

const ColorBar = props => {
  const { score, data: readings } = props;

  const bars =
    readings &&
    readings.length &&
    readings.map((item, i) => {
      if (item.value > 0) {
        return (
          <s.Bar
            key={i}
            className="bar"
            style={{ backgroundColor: item.color, width: `${item.value}%`, }}
            ></s.Bar>
        );
      }
      return null;
    });

  return (
    <div>
      <s.TriangleDiv style={{ width: `${score}%`, }}>
        <s.Triangle />
      </s.TriangleDiv>
      <div className="bars">{bars === '' ? '' : bars}</div>
    </div>
  );
};

ColorBar.propTypes = {
  data: PropTypes.object,
  score: PropTypes.Integer,
};

export default React.memo(ColorBar);
